import React from 'react';
import styled from 'styled-components';
import { Heading, Text } from 'components/styled/ui';
import { images, strings } from 'config'; 

const NetworkError = () => (
  <ErrorMessage lang={strings.getLanguage()}>
  <img src={images.icons.networkError} alt="Network Error" className='icon'/>
  <Heading className='heading' size={18} align="center">{strings.networkError.somethingWrong}</Heading>
  <Text className="text" size={14} align='center'>{strings.networkError.errorMessage}</Text>
</ErrorMessage>
);

export default NetworkError;

const ErrorMessage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 36px 0;


  .icon {
    margin-bottom: 18px;
  }

  .heading{
      margin-bottom: 24px;
      text-align: center;
      color: #989898;
  }

  .text {
    color: #adadad;
    font-size: ${props => props.lang === 'en' ? '14px' : '16px'};
    margin-bottom: 24px;
  }
`;


// WEBPACK FOOTER //
// ./src/components/layouts/networkError/networkError.js